// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#home[data-v-3163554e] {\n    display: flex;\n}\n#error[data-v-3163554e] {\n    margin: 0 auto;\n}\n#body[data-v-3163554e] {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n}\n#rest-of-body[data-v-3163554e] {\n    flex-grow: 1;\n    background-color: white;\n    padding-bottom: 60px;\n}\n", ""]);
// Exports
module.exports = exports;
